import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { DocumentHostComponent } from '@components/element-widgets/document-host/document-host.component';
import { ElementHostComponent } from '@components/element-widgets/element-host/element-host.component';
import { FondsportraitComponent } from '@components/fondsportrait/fondsportrait/fondsportrait.component';
import { GridLayoutComponent } from '@components/layouts/grid-layout/grid-layout.component';
import { HorizontalLayoutComponent } from '@components/layouts/horizontal-layout/horizontal-layout.component';
import { ContentDirective } from '@utils/content.directive';
import { WidgetContentDirective } from '@utils/widget-content.directive';
import { DebugModule } from 'src/app/_debug/debug.module';
import { AuthInterceptorProvider } from 'src/app/common/interceptors/auth.interceptor';
import { apiConfigFactory, OpenApiPathProvider } from 'src/app/common/util/open-api-provider';
import { BoTableComponent } from 'src/app/components/bo-table/bo-table.component';
import { ElementPipe } from 'src/app/element-handling/element.pipe';
import { ApiModule } from 'src/openapi-client';
import { TranslocoRootModule } from 'src/transloco-root.module';
import { ApiVersionInterceptorProvider } from '../app/common/interceptors/api-version.interceptor';
import { DemoComponent } from './demo.component';

@NgModule({
  declarations: [DemoComponent],
  imports: [
    BrowserModule,
    FormsModule,
    TranslocoRootModule,
    HttpClientModule,
    ApiModule.forRoot(apiConfigFactory),
    RouterModule.forRoot([]),

    BoTableComponent,
    DocumentHostComponent,
    HorizontalLayoutComponent,
    GridLayoutComponent,
    ElementHostComponent,
    FondsportraitComponent,

    ContentDirective,
    WidgetContentDirective,

    ElementPipe,

    DebugModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [DemoComponent],
  providers: [
    ApiVersionInterceptorProvider,
    AuthInterceptorProvider,
    OpenApiPathProvider,
  ],
})
export class DemoModule {}
